/**
 * ManualPlayerBadge View Component
 *
 * Renders a muted badge indicating that a player was manually created
 * by an organization user rather than sourced from the database.
 * @module components/ManualPlayerBadge
 */
import React, { memo } from "react";

import { Badge, BadgeText } from "@/components/atoms/Badge";

/**
 * Props for ManualPlayerBadgeView
 */
interface ManualPlayerBadgeViewProps {
  readonly compact: boolean;
}

/**
 * Presentational component for the manual player badge
 * @param root0 - Component props
 * @param root0.compact - When true, renders shorter "MANUAL" text for compact list views
 */
const ManualPlayerBadgeView = ({ compact }: ManualPlayerBadgeViewProps) => (
  <Badge size={compact ? "sm" : "lg"} variant="solid" action="muted">
    <BadgeText className="font-heading">
      {compact ? "MANUAL" : "MANUALLY ADDED"}
    </BadgeText>
  </Badge>
);

ManualPlayerBadgeView.displayName = "ManualPlayerBadgeView";

export default memo(ManualPlayerBadgeView);
